module.exports = __webpack_public_path__ + "img/activity_empty_state.fa2738db.svg";